export enum EnumTermAppointment {
  INDEFINITE = 'I',
  DEFINITE = 'D'
}

export const TERM_APPOINTMENTS = {
  INDEFINITE: 'I',
  DEFINITE: 'D'
} as const

export const NAME_TERM_APPOINTMENTS = {
  I: 'Indefinido',
  D: 'Definido'
}

export const CATALOG_TERM_APPOINTMENTS = [
  {
    value: TERM_APPOINTMENTS.INDEFINITE,
    label: NAME_TERM_APPOINTMENTS.I
  },
  {
    value: TERM_APPOINTMENTS.DEFINITE,
    label: NAME_TERM_APPOINTMENTS.D
  }
]
